import type { EventRoute } from '@/shared/infrastructure/events/eventRouter';
import { characterKeys } from './queryKeys';

export function registerCharacterEvents(
  register: (eventType: string, route: EventRoute) => void,
): void {
  register('character.created', {
    getQueryKeys: (p) => [characterKeys.list(p.familyId as string)],
  });

  register('character.updated', {
    getQueryKeys: (p) => [
      characterKeys.detail(p.characterId as string),
      characterKeys.list(p.familyId as string),
    ],
  });

  register('character.deleted', {
    getQueryKeys: (p) => [characterKeys.list(p.familyId as string)],
  });

  register('character.portrait.completed', {
    // + the wizard's photo-hero cards (PhotoHeroes: ['characters','photo-hero-states', …ids])
    getQueryKeys: (p) => [characterKeys.detail(p.characterId as string), ['characters', 'photo-hero-states'], characterKeys.all],
  });

  register('character.portrait.failed', {
    // + the wizard's photo-hero cards (PhotoHeroes: ['characters','photo-hero-states', …ids])
    getQueryKeys: (p) => [characterKeys.detail(p.characterId as string), ['characters', 'photo-hero-states'], characterKeys.all],
  });
}
